<template>
  <div class="search-detaile table-def-pg">
    <div class="search-pg">
      <Search />
    </div>
    <div class="breadcrumb-wrap">
      <div class="container">
        <v-breadcrumbs :items="breadcrumbs" />
      </div>
    </div>
    <div class="container">
      <div class="position">
        <div class="bg-white p-20">
          <div class="search-body">
            <div class="search-result">
              <div>
                <div class="search-result-body">
                  <div class="type-column">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th>
                              {{ $t('Наименование') }}
                            </th>
                          </tr>
                        </thead>
                        <tbody v-show="showArchive === false" v-if="successorDevelopers.length > 0">
                          <tr
                            v-for="developer in successorDevelopers"
                            :key="developer.developer.id"
                          >
                            <td>
                              <router-link
                                :to="$i18nRoute({
                                  name: 'search-npa',
                                  query: { developer: developer.developer.id }
                                })"
                              >
                                <v-icon
                                  class="nv_icon mr-1"
                                  v-if="developer.developer.status === false"
                                  x-small
                                />
                                {{ developer.developer.transName }}
                              </router-link>
                              <div
                                v-if="
                                  developer.children &&
                                    developer.children.length > 0
                                "
                              >
                                <a
                                  class="show-child-developer"
                                  v-show="!showChildren[developer.developer.id]"
                                  @click="
                                    showChildren[developer.developer.id] = true
                                  "
                                  >{{ $t('Показать') }}</a
                                >
                                <a
                                  class="hide-child-developer"
                                  v-show="showChildren[developer.developer.id]"
                                  @click="
                                    showChildren[developer.developer.id] = false
                                  "
                                  >{{ $t('Скрыть') }}</a
                                >
                                <div
                                  v-show="showChildren[developer.developer.id]"
                                  class="dev-children"
                                >
                                  <span
                                    v-for="child in developer.children"
                                    :key="child.id"
                                  >
                                    <router-link
                                      :to="{
                                        name: 'search-npa',
                                        query: { developer: child.id }
                                      }"
                                    >
                                      <v-icon
                                        class="nv_icon mr-1"
                                        v-if="child.status === false"
                                        x-small
                                      />
                                      {{ child.transName }}
                                    </router-link>
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-show="showArchive === true" v-if="developers.length > 0">
                        <tr
                          v-for="developer in developers"
                          :key="developer.developer.id"
                        >
                          <td>
                            <router-link
                              :to="$i18nRoute({
                                  name: 'search-npa',
                                  query: { developer: developer.developer.id }
                                })"
                            >
                              <v-icon
                                class="nv_icon mr-1"
                                v-if="developer.developer.status === false"
                                x-small
                              />
                              {{ developer.developer.transName }}
                            </router-link>
                            <div
                              v-if="
                                  developer.children &&
                                    developer.children.length > 0
                                "
                            >
                              <a
                                class="show-child-developer"
                                v-show="!showChildren[developer.developer.id]"
                                @click="
                                    showChildren[developer.developer.id] = true
                                  "
                              >{{ $t('Показать') }}</a
                              >
                              <a
                                class="hide-child-developer"
                                v-show="showChildren[developer.developer.id]"
                                @click="
                                    showChildren[developer.developer.id] = false
                                  "
                              >{{ $t('Скрыть') }}</a
                              >
                              <div
                                v-show="showChildren[developer.developer.id]"
                                class="dev-children"
                              >
                                  <span
                                    v-for="child in developer.children"
                                    :key="child.id"
                                  >
                                    <router-link
                                      :to="{
                                        name: 'search-npa',
                                        query: { developer: child.id }
                                      }"
                                    >
                                      <v-icon
                                        class="nv_icon mr-1"
                                        v-if="child.status === false"
                                        x-small
                                      />
                                      {{ child.transName }}
                                    </router-link>
                                  </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </div>
                </div>
                <div class="search-result-footer">
                  <p>{{ $t('Общее количество') }}: {{ showArchive === true ? developersTotal : successorDevelopersTotal }}</p>
                  <p>
                    <a
                      v-show="showArchive === true"
                      @click="showArchive = false"
                      v-if="successorDevelopers.length > 0"
                    >
                      {{ $t('Разработчики') }}
                    </a>
                    <a
                      v-show="showArchive === false"
                      @click="showArchive = true"
                      v-if="developers.length > 0"
                    >
                      {{ $t('Архив разработчиков') }}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CMS from '@/model/cms'
import { mapMutations } from 'vuex'
import Search from '@/components/Search'
import {Trans} from "@/plugins/Translation"

export default {
  components: {
    Search
  },
  data: () => ({
    developers: [],
    successorDevelopers: [],
    breadcrumbs: [],
    developersTotal: 0,
    successorDevelopersTotal: 0,
    showChildren: {},
    showArchive: false
  }),
  watch: {
    '$route.query'(qs) {
      this.fetchData(qs)
    }
  },
  metaInfo () {
    return {
      title: this.$i18n.t('NPADevelopersTitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('NPADevelopersDescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('NPADevelopersKeywordsSEO'),
      }]
    }
  },
  created() {
    this.fetchData(this.$route.query)
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData(qs) {
      this.setLoading(true)
      CMS.getNpaDeveloper()
        .then((response) => {
          this.developers = response.data.items
          this.successorDevelopers = response.data.successorItems

          let self = this
          this.developers.forEach(function(developer) {
            self.$set(self.showChildren, developer.developer.id, false)
          })
          this.developersTotal = response.data.itemsCount
          this.successorDevelopersTotal = response.data.successorItemsCount

          this.breadcrumbs = [
            { text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/' }
          ]

          if (response.data.parentMenu) {
            const breadcrumb = {}
            breadcrumb.text = response.data.parentMenu.transName
            breadcrumb.disabled = true
            this.breadcrumbs.push(breadcrumb)
          }

          this.setLoading(false)
        })
        .catch((error) => {
          //console.log(error)
        })
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
